import React, { useEffect, useState } from 'react'
import { Breadcrumb, Button, FormRow } from '../../components'
import { useDispatch, useSelector } from 'react-redux'
import { fetchEvent, setSelectedTicket } from '../../features/event/slice'
import dayjs from 'dayjs'
import 'dayjs/locale/en'
import { Link, useHistory } from 'react-router-dom'
import platform from '../../database/platform.json'
import ContainerOnMobile from '../../layouts/container-on-mobile'
import { generateSelectedTicket } from '../../utils'
import { useInternationalization } from '../../features/i18n'
const platformById = {}

for (let index = 0; index < platform.length; index++) {
  const element = platform[index];
  platformById[element.id] = element
}

const label = {
  en: 'See Ticket',
  id: 'Lihat Tiket'
}

const List = ({ data }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { language, translate } = useInternationalization()
  const { data: event } = useSelector(state => state.event)

  const handleSeeTicket = (d) => {
    // Generate data for printable ticket detail PDF
    const selectedTicket = generateSelectedTicket(event, d, language)

    dispatch(setSelectedTicket(selectedTicket))
      .then(() => history.push(`/ticket/${event.id}/${d.no}`))
  }

  return (
    <div className="list mb-8 lg:mb-0">
      {
        data &&
        data.map((d, index) => (
          <div
            className="p-5"
            style={{background: index % 2 === 0 ? '#f9f9f9' : 'transparent'}}
            key={d.email}
          >
            <div className="flex flex-wrap -mx-4">
              <div className="w-full lg:w-2/3 px-4 mb-5 lg:mb-0">
                <div className="flex flex-wrap -mx-4 mb-5">
                  <div className="w-1/2 px-4">
                    <p className="font-bold text-xs">{translate('GENERAL', 'name')}</p>
                    <p className="text-gray-444 text-sm">{d.name}</p>
                  </div>
                  <div className="w-1/2 px-4">
                    <p className="font-bold text-xs">{translate('GENERAL', 'occupation')}</p>
                    <p className="text-gray-444 text-sm">{d.occupation}</p>
                  </div>
                </div>
                <div className="flex flex-wrap -mx-4 mb-2">
                  <div className="w-1/2 px-4">
                    <p className="font-bold text-xs">{translate('AUTH', 'email')}</p>
                    <p className="text-gray-444 text-sm break-words">{d.email}</p>
                  </div>
                  <div className="w-1/2 px-4">
                    <p className="font-bold text-xs">{translate('GENERAL', 'phone')}</p>
                    <p className="text-gray-444 text-sm">{d.phone}</p>
                  </div>
                </div>
                <div className="flex flex-wrap -mx-4 mb-2">
                  <div className="w-1/2 px-4">
                    <p className="font-bold text-xs">{translate('GENERAL', 'disability_status')}</p>
                    <p className="text-gray-444 text-sm break-words">{d.disability}</p>
                  </div>
                  <div className="w-1/2 px-4">
                    <p className="font-bold text-xs">{translate('GENERAL', 'gender')}</p>
                    <p className="text-gray-444 text-sm">{d.gender}</p>
                  </div>
                </div>
              </div>
              <div className="w-full lg:w-1/3 px-4">
                <Button thin onClick={() => handleSeeTicket(d)}>
                  {label[language.name]}
                </Button>
              </div>
            </div>
          </div>
        ))
      }
    </div>
  )
}

const DashboardTicketsDetail = ({ match }) => {
  const dispatch = useDispatch()
  const language = useSelector(state => state.system.language)
  const { translate } = useInternationalization()
  const { data } = useSelector(state => state.event)
  const tickets = useSelector(state => state.account.tickets)
  const [selectedTicket, setSelectedTicket] = useState({})

  const {
    title = {},
    start_date,
    end_date,
    location,
    location_online = {}
  } = data

  const {
    guests = []
  } = selectedTicket

  const dateFormatted = `${dayjs(start_date).locale('en').format('ddd, MMM DD, YYYY, h:mm A')} -<br />${dayjs(end_date).locale('en').format('ddd, MMM DD, YYYY, h:mm A')}`

  useEffect(() => {
    if(match.params && match.params.id){
      dispatch(fetchEvent(match.params.id))
      const newSelectedTicket = tickets.find(e => e.event_id === parseInt(match.params.id))

      if(newSelectedTicket){
        setSelectedTicket(newSelectedTicket)
      }
    }
  }, [dispatch, match.params, tickets])

  const getLogo = (id) => {
    return platformById[id].logo
  }

  const routes = [
    {
      name: translate('DASHBOARD', 'event_tickets'),
      route: '/dashboard/tickets'
    }
  ]

  return (
    <ContainerOnMobile>
      <div className="hidden lg:block">
        <Breadcrumb routes={routes}/>
      </div>
      <h1 className="text-lg lg:text-4xl font-primary pt-5 lg:pt-0">
        {translate('EVENT', 'ticket_for')} <Link className="font-bold underline" to={`/event/${match.params.id}/detail`}>
          {title[language.name]}
        </Link>
      </h1>
      <hr className="mt-5 mb-8"/>
      <div className="flex flex-wrap -mx-4">
        <div className="w-full lg:w-1/3 px-4">
          {/* <FormRow>
            <p className="font-bold mb-2 text-xs">Order Number</p>
            <p className="text-gray-444 text-sm">
              #996087991
            </p>
          </FormRow> */}
          <FormRow>
            <p className="font-bold mb-2 text-xs">
              {translate('GENERAL', 'date_and_time')}
            </p>
            <div
              className="text-gray-444 text-sm"
              dangerouslySetInnerHTML={{__html: dateFormatted}}
            />
          </FormRow>
          <FormRow>
            <p className="font-bold mb-2 text-xs">
              {translate('GENERAL', 'location')}
            </p>
            <div
              className="text-gray-444 text-sm"
              dangerouslySetInnerHTML={{__html: location}}
            >
              {/* Hotel Grand Tjokro<br />
              Jalan Daan Mogot No.63<br />
              Tj. Duren Utara<br />
              Kec. Grogol petamburan, Daerah Khusus Ibukota <br />Jakarta 11470 */}
            </div>
          </FormRow>
          <FormRow last>
            <p className="font-bold mb-2 text-xs">Media</p>
            {
              location_online.platform_id ? <>
                <div className="text-gray-444">
                  {
                    location_online.url ? (
                      <a
                        className="inline-block p-4 border rounded mb-4"
                        href={location_online.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {
                          platformById[location_online.platform_id] ? (
                            <img
                              src={getLogo(location_online.platform_id)}
                              alt={location_online.channel}
                              width="150"
                              height="75"
                            />
                          ) : (
                            location_online.channel
                          )
                        }
                      </a>
                    ) : <>
                      {
                        platformById[location_online.platform_id] ? (
                          <img
                            src={getLogo(location_online.platform_id)}
                            alt={location_online.channel}
                            width="150"
                            height="75"
                            title="TBA"
                          />
                        ) : (
                          <p className="text-sm" title="TBA">{location_online.channel}</p>
                        )
                      }
                    </>
                  }
                </div>
              </> : '-'
            }
          </FormRow>
        </div>
        <div className="w-full lg:w-2/3 px-4">
          <p className="lg:text-lg font-bold mb-4 lg:mb-8">{translate('GUEST', 'plural')} ({guests.length})</p>
          <div className="mobile-fullwidth">
            <List data={guests}/>
          </div>
        </div>
      </div>
    </ContainerOnMobile>
  )
}

export { DashboardTicketsDetail }
